import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Alert, Button, Card, Select } from 'antd';
import { map, omit } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../AppContext';
import { ROUTES } from '../../../common/constants';
import EditableTable from '../../../components/EditableTable';
import EnvFileUploader from '../../../components/EnvFileUploader';
import useRouter from '../../../hooks/useRouter';
import { ADD_KEYS } from '../graphql/Mutations';
import { GET_ENVIRONMENTS } from '../graphql/Queries';

export default function UplodeKeys() {
  const {
    navigate,
    location: { state },
  } = useRouter();
  const { setProjectTopicId } = useContext(AppContext);
  const [environments, setEnvironments] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [fileContent, setFileContent] = useState([]);
  const [editingKey, setEditingKey] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState('');
  const [rowErrors, setRowErrors] = useState([]);

  const [fetchEnvironment, { loading: environmentLoading }] = useLazyQuery(
    GET_ENVIRONMENTS,
    {
      fetchPolicy: 'network-only',
      onCompleted: (res) => {
        setEnvironments(res?.environments?.data);
      },
    },
  );
  useEffect(() => {
    fetchEnvironment({
      variables: {
        where: {
          projectTopicId: state?.topicsId,
        },
      },
    });
  }, [fetchEnvironment, state?.topicsId]);

  const [addKeys] = useMutation(ADD_KEYS, {
    onCompleted() {
      navigate(ROUTES?.MAIN, {
        state: {
          projectData: state?.projectData,
          topicsId: state?.topicsId,
        },
      });
    },
    onError() {},
  });

  const handleClick = () => {
    const hasInvalid = fileContent?.some(
      (item) => !item?.key || item?.isValid === false,
    );
    if (hasInvalid) {
      setError('Please fix all validation errors before saving.');
      return;
    }
    addKeys({
      variables: {
        data: {
          environmentId: selectedBranch,
          keyValues: map(fileContent, (item) => omit(item, ['isValid', 'id'])),
          projectTopicId: state?.topicsId,
        },
      },
    });
  };

  return (
    <div className="table-card-page">
      <Card
        title={
          <>
            <div className="d-flex gap-16 align-center">
              <Button
                type="text"
                shape="square"
                onClick={() => {
                  setProjectTopicId(null);
                  navigate(ROUTES.MAIN, {
                    state: {
                      projectData: state?.projectData,
                      topicsId: state?.topicsId,
                    },
                  });
                }}
                icon={<ArrowLeftOutlined />}
              />
              <h2 className="m-0">Upload Keys</h2>
              <div className="d-flex ml-16 justify-between full-width">
                <div className="d-flex gap-16 ">
                  <Select
                    className="env-selection"
                    options={environments?.map((env) => ({
                      value: env?.id,
                      label: env?.name,
                    }))}
                    value={selectedBranch}
                    loading={environmentLoading}
                    placeholder="Select ENV"
                    onSelect={(value) => {
                      setSelectedBranch(value);
                    }}
                    onChange={() => {
                      setError('');
                      setFileContent([]);
                    }}
                  />
                  <EnvFileUploader
                    fileContent={fileContent}
                    editingKey={editingKey}
                    setFileContent={setFileContent}
                    setEditingKey={setEditingKey}
                    setError={setError}
                    selectedBranch={selectedBranch}
                  />
                </div>
                <div className="mr-12">
                  <Button
                    type="primary"
                    onClick={handleClick}
                    disabled={
                      isEditing ||
                      fileContent <= 0 ||
                      fileContent?.some((row) => row?.isValid === false) ||
                      rowErrors?.length > 0
                    }
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </>
        }
        className="ant-body-scroll"
      >
        <div className="uploadEnv-table m-12">
          {error && (
            <Alert className="ml-16" message={error} type="error" showIcon />
          )}
          {fileContent?.length > 0 && (
            <EditableTable
              fileContent={fileContent}
              setFileContent={setFileContent}
              setError={setError}
              setIsEditing={setIsEditing}
              handleClick={handleClick}
              setRowErrors={setRowErrors}
              rowErrors={rowErrors}
            />
          )}
        </div>
      </Card>
    </div>
  );
}
